<template>
 <o-p-pending-component/>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style>
</style>